<template>
	<div class="hello">
		<div class="__nav-bar-container">
			<div class="header-container fir">
				<!-- <div class="el-image header-img">
				<div style="position: absolute;z-index: 99;"><img src="../static/logo_test.png" style="object-fit: cover;width: 131px;"/></div>
				<img src="../static/banner.b20969c8.jpg" class="el-image__inner" style="object-fit: cover;">
			</div> -->
				<div style="width:1440px;margin: 0 auto;padding: 0 50px;box-sizing: border-box; display: flex;align-items: center;height: 120px;">
					<div style="width:50%; display: flex;justify-content: center;align-items: center;flex-direction: column;">
						<div style="font-size: 36px; color:#3894FF;	 " >
							广州维握信息科技有限公司
						</div>
						
					</div>
					<div class="flex-align-center nav-container">
						<div class="page-center-content nav-search flex-align-center">
							<div class="flex-align-center" style="width: 100%;">
								<div class="nav-content">
									<router-link class="item" to="/">
										<div>首页</div>
									</router-link>
								</div>
								<div class="nav-content">
									<router-link to="/cpfw" class="item">
										<div>产品服务</div>
									</router-link>
								</div>
								<div class="nav-content">
									<router-link class="item" to="/khal">
										<div>客户案例</div>
									</router-link>
								</div>
								<div class="nav-content">
									<router-link class="item" to="/gywm">
										<div>关于我们</div>
									</router-link>
								</div>
								<div class="nav-content">
									<router-link class="item" to="/lxfs">
										<div>联系方式</div>
									</router-link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			
		</div>
	</div>
</template>

<script>
	export default {
		name: 'HeaderPart',
		props: {

		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
	.__nav-bar-container {
		z-index: 600;
		width: 100%;
		position: relative;
		display: flex;
		flex-direction: column;
	}

	.header-container {
		position: relative;

		.header-img {
			z-index: -1;
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
		}
	}

	.fir,
	.sec {
		height: 120px;
	}

	.nav-container {
		// background-color: #0061AE;
		margin: 0 50px;
	}

	.flex-align-center {
		display: flex;
		align-items: center;
		justify-content: space-between;
		
	}

	.flex-row-center {
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	.page-center-content {
		// width: 1200px;
		padding: 0 auto;
	}

	.nav-search {
		.nav-content {
			cursor: pointer;
			position: relative;
			transition: opacity 1s linear;
			text-align: center;
			width: 150px;
			// height: 76px;
			height: 50px;

			.item {
				height: 100%;
				text-decoration: none;
				font-size: 18px;
				// font-weight: bold;
				color: #101010;
				display: flex;
				align-items: center;
				justify-content: center;
				flex-direction: column;

				.parent-icon {
					margin-bottom: 10px;
					width: 22px;
				}
			}
			.item:hover {
				color: #3894FF;
				font-weight: bold;
			}
			.child-item-menu {
				display: none;
				z-index: 100;
				position: absolute;
				top: 100%;
				left: 0;
				width: 100%;
				background: #0061AE;
				opacity: 0;
				color: #fff;
				font-size: .09412rem;

				.item-menu {
					display: flex;
					align-items: center;
					flex-wrap: wrap;
					flex-direction: column;
					color: #f8e8e9;

					.child-item {
						display: flex;
						align-items: center;
						justify-content: center;
						width: 100%;
						height: 45px;

					}

					.child-item:hover {
						background-color: #42C7FF;
					}

					.menu-a {
						line-height: 60px;
						text-decoration: none;
						display: block;
						font-size: 14px;
						color: #fff;
					}

					.menu-a::before {
						content: " ▪ ";
					}
				}
			}
		}

		.nav-content:hover {
			// background: #42C7FF;
			
			.child-item-menu {
				display: block;
				opacity: 1;
			}
		}
	}
</style>